import{gql as e}from"@apollo/client";const t=e`
  query getLatestUserFlowStepTracking($userFlowStepId: Int!) {
    userFlowStepTrack {
      getLatestUserFlowStepTracking: latestTracking(userFlowStepId: $userFlowStepId) {
        completed
        completedLongDate
        configuration
        created
        createdLongDate
        id
        instance
        instanceDate
        isCompleted
        isMarked
        started
        startedLongDate
        userFlowStepId
        userId
      }
    }
  }
`;export{t as GET_LATEST_USER_FLOW_STEP_TRACKING_QUERY};
//# sourceMappingURL=useGetLatestUserFlowStepTracking.graphql.js.map
